<template>
  <el-form :inline="true" v-loading="fetching">
    <el-card>
      <div slot="header">{{title}}</div>
      <div slot="actions">
        <el-button plain @click="add">Add</el-button>
      </div>
      <category-editor
        :category="category"
        :type="type"
        v-for="(category, index) in categories"
        :key="index"
      />
      <category-editor
        :category="category"
        :type="type"
        v-for="(category, index) in newCategories"
        :key="`new-`+index"
        :handleRemove="remove"
      />
    </el-card>
  </el-form>
</template>

<script>
  import moment from 'moment';
  import { mapGetters } from 'vuex';

  import CategoryEditor from '@/components/category/CategoryEditor';

  export default {
    name: 'CategoriesManager',
    props: {
      app: {
        type: Object,
        required: true,
      },
      title: {
        type: String,
        required: true,
      },
      type: {
        type: String,
        required: true,
      },
      categories: {
        type: Array,
      },
    },
    components: {
      categoryEditor: CategoryEditor,
    },
    data() {
      return {
        newCategories: [],
      };
    },
    computed: {
      ...mapGetters('entities/categories', ['fetching']),

      allCategories() {
        return [...this.categories, ...this.newCategories];
      },
    },
    methods: {
      add() {
        this.newCategories.push({
          key: moment(),
          name: '',
          app_id: this.app.id,
          type: this.type,
          status: 'active',
          editable: true,
        });
      },
      remove(key) {
        this.newCategories = this.newCategories.filter(category => !category.key.isSame(key));
      },
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/category/CategoriesManager.vue